export default __webpack_public_path__ + "static/media/action-edit_darkGray3.d60719e4.svg";